import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import malavika from "../Images/malavika.jpg"
import sudharani from "../Images/instant-cash-for-gold.jpg"
import Sliding from './Sliding';
function SliderLang() {
  return (
    <div className='container'>

      <div className='sub-hading'>
        <h2 className='section-sub-heading'>వార్తలు & ప్రమోషన్లు/NEWS  &  PROMOTIONS</h2>
      </div>
      <section className='carausel-main-section'>

        <div className='container'>
          <div id="carouselExampleControls" className="carousel slide">
            <div className="carousel-inner " >
              <div className="carousel-item active" >
                <img className="img-fluid" src={sudharani} alt="First slide" />
                <div className="carousel-caption ">
                  <p className=''>Cash on hand is handier during a financial crunch, instant cash for gold is a favorable choice</p>
                </div>
              </div>
              <div className="carousel-item" >
                <img className="img-fluid" src={malavika} alt="Second slide" />
                <div className="carousel-caption ">
                  <p className=''>Top gold-silver jewelry-buying & selling companies in India have a few common traits</p>
                </div>
              </div>
            </div>

            <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

      </section>
    </div>
  )
}

export default SliderLang

